export const EXPERIENCE_MODEL = "experience";

const experienceModel = {
  jobTitle: "",
  keyResponsibilities: "",
  organisation: "",
  reasonForLeaving: "",
  startDate: "",
  endDate: "",
  experienceFunctionId: "",
  experienceFunction: "",
  user: {
    jsonApi: "hasOne",
    type: "users"
  }
};

export default experienceModel;
